import {sharedCampaigns} from '@cl/shared';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTWeightedNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';

function createDefaultWeightedCard(): DTWeightedNode {
  return {
    id: NO_NODE_ID,
    name: 'Weighted Card',
    description: '',
    type: NodeType.WEIGHTED,
    x: 0,
    y: 0,
    outputs: [
      {id: 1, name: 'Output 1', weight: 50, nodeId: NO_NODE_ID},
      {id: 2, name: 'Output 2', weight: 50, nodeId: NO_NODE_ID},
    ],
    inputs: [],
    shouldSplitAudience: false,
  };
}

/**
 * Gets an existing weighted card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0/undefined for a new card
 * @returns The weighted card (existing or new)
 */
async function getOrCreateWeightedCard(
  cardId: number | undefined,
  _store: CLStore,
): Promise<DTWeightedNode> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.WEIGHTED) {
      throw new Error(`Card with id ${resolvedCardId} is not a weighted card`);
    }

    return existingCard as DTWeightedNode;
  }

  return createDefaultWeightedCard();
}

export default getOrCreateWeightedCard;
export {createDefaultWeightedCard};
